const ID = 'checkout-state';
const CREATE_TYPE = 'checkout-created';
const ADD_TYPE = 'line-item-added';

class IframeSDKCheckoutUpdates {
  constructor(parentPage) {
    this.parentPage = parentPage;
  }

  checkoutCreated({ checkoutId, cartEnabled, lineItemRequest, lineItem }) {
    window.parent.postMessage(
      {
        meta: {
          placementType: ID,
          type: CREATE_TYPE,
        },
        data: {
          checkoutId,
          cartEnabled,
          skuId: lineItemRequest.skuId,
          releaseId: lineItemRequest.releaseId,
          externalId: lineItem.sku.externalId,
          price: lineItem.price,
        },
      },
      '*'
    );
  }

  lineItemAdded({ checkoutId, cartEnabled, lineItemRequest, lineItem }) {
    window.parent.postMessage(
      {
        meta: {
          placementType: 'checkout-state',
          type: ADD_TYPE,
        },
        data: {
          checkoutId,
          cartEnabled,
          skuId: lineItemRequest.skuId,
          releaseId: lineItemRequest.releaseId,
          externalId: lineItem.sku.externalId,
          price: lineItem.price,
        },
      },
      '*'
    );
  }

  onChangeShownToUser(cb) {
    window.addEventListener('message', (ev) => {
      const { type } = ev.data;

      if (!type) {
        return;
      }

      if (type === 'CHECKOUT_SHOWN') {
        cb();
        return;
      }

      if (type === 'CART_SHOWN') {
        cb();
      }
    });
  }
}

export { IframeSDKCheckoutUpdates };
